import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { ThemeProvider, useTheme } from '@nucleus-commerce/admin-kit/theme';
import { Toaster } from '@nucleus-commerce/ui/components/sonner';
import { TooltipProvider } from '@nucleus-commerce/ui/components/tooltip';

import { devtoolsEnabled } from './devtools';
import { i18n } from './i18n';
import { queryClient } from './query-client';

function ThemedToaster() {
  const { resolved } = useTheme();
  return <Toaster theme={resolved} position="bottom-right" closeButton richColors />;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider defaultPreference="dark">
          <TooltipProvider delayDuration={300}>
            {children}
            <ThemedToaster />
          </TooltipProvider>
        </ThemeProvider>
      </I18nextProvider>
      {devtoolsEnabled ? <ReactQueryDevtools buttonPosition="bottom-right" /> : null}
    </QueryClientProvider>
  );
}
